import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { RelatoriosContent } from '@/shared/components/relatorios/relatorios-content';

@Component({
    selector: 'app-medico-relatorios-content',
    standalone: true,
    imports: [RouterModule, RelatoriosContent],
    template: `
        <div class="flex flex-wrap">
            <div class="xl:w-4/5 lg:w-4/6 md:w-full sm:w-full xs:w-full w-full sm:!w-full-revert">
                <app-relatorios-content [itens]="itens"></app-relatorios-content>
            </div>
        </div>
    `
})
export class OrientacoesRelatoriosContent implements OnInit {
    itens: MenuItem[] = [];

    ngOnInit(): void {
        this.itens = [
            { label: 'Controle Administrativo', routerLink: 'controle-administrativo' },
            { label: 'Endereço Desatualizado', routerLink: 'endereco-desatualizado' },
            { label: 'Emissão de Etiquetas', routerLink: 'emissao-etiquetas' },
            { label: 'RNE - Registro Nacional de Estrangeiros', routerLink: 'rne' },
            { label: 'Listagem Geral de PCMSO', routerLink: 'listagem-pcmso' },
            { label: 'Listagem de Médicos Por Período', routerLink: 'listagem-medicos-periodo' },
            { label: 'Telemedicina', routerLink: 'telemedicina' },
            { label: 'Consultório Privado', routerLink: 'consultorio-privado' },
            { label: 'Conflito de Interesse', routerLink: 'conflito-interesse' },
            { label: 'Médicos Ativos Por Data', routerLink: 'medicos-ativos-data' }
        ];
    }
}
